<template>
  <div class="password-container">
    <el-row style="margin-bottom:10px">
      <el-col :xl="1" :lg="1" :md="1" :sm="1" :xs="1">
        <i class="fas fa-lock lock-icon"></i>
      </el-col>
      <el-col :xl="19" :lg="19" :md="19" :sm="19" :xs="19">
        <span class="password-title">Your password needs to:</span>
      </el-col>
    </el-row>
    <el-row class="no-margin">
      <el-col :offset="1" :xl="19" :lg="19" :md="19" :sm="19" :xs="19">
          <i v-if="hasExistingValidation(',length')" class="fas fa-check passed"></i>
          <i v-else class="fas fa-times failed"></i>
          <span :class="getClass(hasExistingValidation(',length'))">&nbsp;be at least 8 characters long</span>
      </el-col>
    </el-row>
    <el-row class="no-margin">
      <el-col :offset="1" :xl="19" :lg="19" :md="19" :sm="19" :xs="19">
          <i v-if="hasExistingValidation(',specialcharacter')" class="fas fa-check passed"></i>
          <i v-else class="fas fa-times failed"></i>
          <span :class="getClass(hasExistingValidation(',specialcharacter'))">&nbsp;include at least 1 special chacter</span>
      </el-col>
    </el-row>
    <el-row class="no-margin">
      <el-col :offset="1" :xl="19" :lg="19" :md="19" :sm="19" :xs="19">
          <i v-if="hasExistingValidation(',uppercase')" class="fas fa-check passed"></i>
          <i v-else class="fas fa-times failed"></i>
          <span :class="getClass(hasExistingValidation(',uppercase'))">&nbsp;include at least 1 upper case character</span>
      </el-col>
    </el-row>
    <el-row class="no-margin">
      <el-col :offset="1" :xl="19" :lg="19" :md="19" :sm="19" :xs="19">
          <i v-if="hasExistingValidation(',lowercase')" class="fas fa-check passed"></i>
          <i v-else class="fas fa-times failed"></i>
          <span :class="getClass(hasExistingValidation(',lowercase'))">&nbsp;include at least 1 lower case character</span>
      </el-col>
    </el-row>
    <el-row class="no-margin">
      <el-col :offset="1" :xl="19" :lg="19" :md="19" :sm="19" :xs="19">
          <i v-if="hasExistingValidation(',number')" class="fas fa-check passed"></i>
          <i v-else class="fas fa-times failed"></i>
          <span :class="getClass(hasExistingValidation(',number'))">&nbsp;include at least 1 number</span>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'PasswordChecklist',
  props: {
    Data: {
      type: Array,
      default: []
    }
  },
  methods: {
    getClass(passed) {
      if (passed) {
        return 'passed';
      }

      return 'failed-text';
    },
    hasExistingValidation(value) {
      return this.$props.Data.find(c => c === value) == null;
    }
  }
}
</script>

<style scoped>
.password-container {
  padding: 10px;
}

.lock-icon {
  color: red;
}

.password-title {
   color: red;
   font-size: 12px;
}

.passed {
  color: #27e327;
  font-size: 12px;
}

.failed {
  color: red;
  font-size: 12px;
}

.failed-text {
  color: black;
  font-size: 12px;
}

.no-margin {
  margin-bottom: 0;
}
</style>